/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TPublishOfferModel,
  IPublishOfferRequest,
  IMappers,
  IPublishOfferSuccessResponse,
  IPublishOfferFailResponse,
  TPublishOfferResponse
} from "./types";

const defaultConfig: TPublishOfferModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: `/addform/v2/offers/`,
  hostType: 'ud-api',
} as TPublishOfferModel;

function createPublishOfferModel(
  parameters: IPublishOfferRequest,
  query?: string,
): TPublishOfferModel {
  return {
    ...defaultConfig,
    // WARNING Монолит использует GET-параметры isArchived, isFromXML, isDealRent.
    ...(query && { pathApi: `${defaultConfig.pathApi}${query}` }),
    parameters,
  };
}

export interface IPublishOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IPublishOfferRequest;
  query?: string;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchPublishOffer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  query,
  config,
  mappers
}: IPublishOfferOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TPublishOfferResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createPublishOfferModel(parameters, query),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublishOfferSuccessResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IPublishOfferFailResponse);
    }
  }

  return { response, statusCode } as TPublishOfferResponse;
}

export { defaultConfig, createPublishOfferModel, fetchPublishOffer };
